export const addParentSuffixToOption = (option: string, parentKey: string) =>
  `${option}__${parentKey}__`

export const getOptionAndSuffixDetails = (
  optionWithPotentialSuffix: string,
): { pureOption: string; suffix: string | null } => {
  const suffixRegex = /__(.*?)__$/
  const match = optionWithPotentialSuffix.match(suffixRegex)

  if (match && typeof match[1] !== 'undefined') {
    const fullSuffix = match[0]
    const suffixValue = match[1]
    const pureOptionValue = optionWithPotentialSuffix.substring(
      0,
      optionWithPotentialSuffix.length - fullSuffix.length,
    )
    return {
      pureOption: pureOptionValue,
      suffix: suffixValue,
    }
  }
  return { pureOption: optionWithPotentialSuffix, suffix: null }
}
